import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { BaseButton as Button } from '../../../../../BaseComponents';
import { Money } from '../../../../../Money';
import { useTheme } from '../../../../../theme';
import { SafeHtml } from '@shared/ui';
const UpsaleItem = ({ title, service, onChange, footer, className }) => {
    const { Upsale: { UpsaleItem: theme } } = useTheme('Features');
    const { t } = useTranslation('AIPurchasePredictionService');
    return (React.createElement("div", { className: cn(theme.root, className) },
        title && React.createElement("div", { className: theme.header }, title),
        React.createElement("div", { className: theme.card },
            React.isValidElement(service.header) &&
                React.cloneElement(service.header, {
                    className: theme.serviceHeader
                }),
            React.createElement("div", { className: theme.content },
                React.createElement("div", { className: theme.description },
                    React.createElement("div", { className: theme.label }, service.name),
                    typeof service.description === 'string' ? (React.createElement(SafeHtml, { html: service.description })) : (service.description),
                    React.createElement("span", null, t('All flights'))),
                React.createElement("div", { className: theme.cost },
                    React.createElement(Money, { money: service.price, moneyClassName: theme.price }),
                    onChange && (React.createElement(Button, { variant: 'optionEdit', onClick: onChange }, t('Change')))))),
        footer));
};
export default UpsaleItem;
